// This is a magic string replaced by rollup

const SDK_VERSION = "8.48.0";
export { SDK_VERSION };
